import { UserType } from '@avanta/shared/constants/users';
import { type UserState, createUserSlice } from '@avanta/shared/stores/user';
import { type User } from '@avanta/shared/types/users';
import { create } from 'zustand';

interface EnterpriseUserExtension {
  enterpriseId: string;
}

type EnterpriseUserState = UserState & EnterpriseUserExtension;

const getEnterpriseId = (user: User): string => {
  if (user.type === UserType.ENTERPRISE) return user.id;
  return user.enterpriseId;
};

export const useUserStore = create<EnterpriseUserState>()((set, get, api) => ({
  ...createUserSlice<UserState>()(set, get, api),
  enterpriseId: '',
  setUser: (user: User): void => {
    set({ enterpriseId: getEnterpriseId(user), user });
  },
}));

export const useEnterpriseId = (): string => useUserStore(state => state.enterpriseId);
